import React from 'react';

export const GRID_COLS_STORAGE_KEY = 'toolsGridCols';
export const GRID_COLS_OPTIONS = [2, 4, 6];
export const GRID_COLS_TO_LG_CLASS = { 2: 'col-lg-6', 4: 'col-lg-3', 6: 'col-lg-2' };

export const readStoredGridCols = () => {
    try {
        const saved = Number(window.localStorage.getItem(GRID_COLS_STORAGE_KEY));
        return GRID_COLS_OPTIONS.includes(saved) ? saved : 4;
    } catch {
        return 4;
    }
};

export const writeStoredGridCols = (cols) => {
    try {
        window.localStorage.setItem(GRID_COLS_STORAGE_KEY, String(cols));
    } catch {
        // localStorage unavailable — ignore
    }
};

const GridSizeIcon = ({ cols }) => {
    const squares = Array.from({ length: cols });
    const perRow = cols === 2 ? 2 : cols === 4 ? 2 : 3;
    return (
        <span
            className="grid-size-icon"
            style={{ gridTemplateColumns: `repeat(${perRow}, 1fr)` }}
        >
            {squares.map((_, i) => <i key={i} />)}
        </span>
    );
};

const GridSizeToggle = ({ gridCols, onChange, allowedOptions = GRID_COLS_OPTIONS }) => (
    <div className="grid-size-toggle">
        {allowedOptions.map(cols => (
            <button
                key={cols}
                type="button"
                className={`grid-size-toggle-btn ${gridCols === cols ? 'active' : ''}`}
                title={`نمایش ${cols} ستونی`}
                onClick={() => onChange(cols)}
            >
                <GridSizeIcon cols={cols} />
            </button>
        ))}
    </div>
);

export default GridSizeToggle;
